/**
 * Парсит дату из строки (дд.мм.гггг, дд/мм/гггг или yyyy-mm-dd). Возвращает { day, month, year } или null.
 */
function parseContractDate(dateRaw) {
  if (!dateRaw || typeof dateRaw !== 'string') return null;
  const s = dateRaw.trim();
  // дд.мм.гггг или дд/мм/гггг
  const dotOrSlash = s.match(/^(\d{1,2})[./](\d{1,2})[./](\d{4})$/);
  if (dotOrSlash) {
    const [, day, month, year] = dotOrSlash;
    return { day: day.padStart(2, '0'), month: month.padStart(2, '0'), year };
  }
  // yyyy-mm-dd
  const iso = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
  if (iso) {
    const [, year, month, day] = iso;
    return { day: day.padStart(2, '0'), month: month.padStart(2, '0'), year };
  }
  const d = new Date(s);
  if (!isNaN(d.getTime())) {
    return {
      day: String(d.getDate()).padStart(2, '0'),
      month: String(d.getMonth() + 1).padStart(2, '0'),
      year: String(d.getFullYear())
    };
  }
  return null;
}

/**
 * Формирует имя файла для скачивания договора: тип договора + дата из договора (не текущая).
 * @param {{ templateId: string, data?: { header?: { date?: string } } }} contract - объект договора (достаточно templateId и data.header.date)
 * @param {'word'|'pdf'} format
 * @param {(id: string) => { name?: string } | undefined} getTemplateById - функция получения шаблона по id
 * @returns {string}
 */
export function getDownloadFilename(contract, format, getTemplateById) {
  const templateName =
    getTemplateById?.(contract.templateId)?.name ||
    (contract.templateId === 'rent_apartment' ? 'Договор найма жилого помещения' : 'Договор');
  const sanitized =
    templateName.replace(/\s+/g, '_').replace(/[<>:"/\\|?*]/g, '') || 'Договор';
  const dateRaw = contract.data?.header?.date;
  const parsed = parseContractDate(dateRaw);
  const dateStr = parsed
    ? `${parsed.day}_${parsed.month}_${parsed.year}`
    : (() => {
        const now = new Date();
        return `${String(now.getDate()).padStart(2, '0')}_${String(now.getMonth() + 1).padStart(2, '0')}_${now.getFullYear()}`;
      })();
  const ext = format === 'word' ? 'docx' : 'pdf';
  return `${sanitized}_${dateStr}.${ext}`;
}
